import React from "react"
import PropTypes from "prop-types"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import getId from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import History from "@irati/utils/history"
import GetInsWizard from "@irati/insights/apollo/client/query/InsWizard"
import {injectRoute} from "@irati/utils/helpers/routing"
import SaveCycleAndQuestions from "@irati/insights/apollo/mutation/wizard/SaveCycleAndQuestions"

import {NarrowStepIndicator} from "../../../ui/StepIndicator"
import {STEPS} from "../../../utils/constants/wizard"
import {ActionsWrapper, Footer} from "../index"


const EditFooter = (props, context) => {
  const idNamespace = "UniversalFooter"

  return (
    <GetInsWizard>
      {({nextURL, prevURL, isEditMode}) => {
        const prevButtonContentId = isEditMode ? "insights.schedule.edit.cancel" : "insights.wizard.step2.cta.back"
        const nextButtonContentId = isEditMode ? "insights.schedule.edit.save" : "insights.wizard.step2.cta.next"
        return (
          <SaveCycleAndQuestions onCompleted={({createSchedule, schedule}) => {
            const scheduleId = createSchedule ? createSchedule.id : schedule.id
            History.push(injectRoute(nextURL, {scheduleId}), context)
          }}>
            {(save, {loading}) => {
              return (
                <Footer>
                  <ActionsWrapper>
                    <ButtonRouterLink id={getId("GoBackButton", idNamespace)} to={prevURL}>
                      <FormattedMessage id={prevButtonContentId} />
                    </ButtonRouterLink>
                  </ActionsWrapper>

                  <NarrowStepIndicator activeStep={2} steps={STEPS} />

                  <ActionsWrapper>
                    <Button id={getId("SaveDraftButton", idNamespace)} apolloState={{loading}} onClick={save} primary>
                      <FormattedMessage id={nextButtonContentId} />
                    </Button>
                  </ActionsWrapper>
                </Footer>
              )
            }}
          </SaveCycleAndQuestions>
        )
      }}
    </GetInsWizard>
  )
}

EditFooter.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default EditFooter
